import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchAdSetsWithSearchCriteria} from "../../services/facebook-ad-set-data.service";
import AdSetFilters from "./ad-set-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import AddEditAdSet from "./add-edit-ad-set";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {AD_SET_FIELDS_LIST} from "../../constants/ad-set.constant";
import ShowProductImages from "../../../shopify/components/product/show-prouct-images";
import DesignAdCreativeImages from "../ad-creative/design-ad-creative-images";
import AddEditImageMedia from "../../../marketing/components/media-editor/add-edit-image-media";
import AddEditMultipleImageMedia from "../../../marketing/components/media-editor/add-edit-multiple-image-media";

const defaultFilterCriteria: any = {};

const AdSetsList = ({
                        campaign = undefined,
                        designDetail = undefined,
                        refreshList = false,
                        setRefreshList = undefined
                    }) => {
    const [adSetsList, setAdSetsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    useEffect(() => {
        if (refreshList) {
            setRefreshList(false);
            getAdSetList();
        }
    }, [refreshList]);

    const getAdSetList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        if (campaign) {
            searchCriteriaList.push({field: 'campaign_id', condition: '==', value: campaign?.id});
        }

        if (designDetail) {
            searchCriteriaList.push({field: 'designId', condition: '==', value: designDetail?.id});
        }

        const adSetListResult = await searchAdSetsWithSearchCriteria(searchCriteriaList);

        setAdSetsList(adSetListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getAdSetList();
    }, [filterCriteria]);

    const refreshAdSetList = async () => {
        await getAdSetList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Campaign Ad Sets
                    </div>

                    {/*<AdSetFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    {!campaign &&
                        <div className="ml-2">
                            <AddEditAdSet
                                isAddAdSet={true}
                                refreshAdSetList={refreshAdSetList}/>
                        </div>
                    }
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={adSetsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Ad Sets'}/>

                    {adSetsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {AD_SET_FIELDS_LIST?.map((adSetField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${adSetField?.cssClass}`}>{adSetField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {adSetsList?.map((adSet, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {AD_SET_FIELDS_LIST?.map((adSetField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${adSetField?.cssClass}`}>
                                                {adSetField?.optionsMap &&
                                                    <>{adSetField?.optionsMap[adSet[adSetField?.attribute]]?.name}</>
                                                }

                                                {!adSetField?.optionsMap &&
                                                    <>
                                                        {adSet[adSetField?.attribute]}

                                                        {adSetField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {adSet[adSetField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-64">
                                        <div className="flex justify-center">
                                            <div className={'m-1'}>
                                                <AddEditAdSet
                                                    isEditAdSet={true}
                                                    selectedAdSet={adSet}
                                                    refreshAdSetList={refreshAdSetList}/>
                                            </div>

                                            {/*<div className={'m-1'}>
                                                <AddEditMultipleImageMedia
                                                    isAddImageMedia={true}
                                                    mediaFor={adSet}
                                                    cssClass={'button-green-outline px-2 py-1'}
                                                    refreshImageMediaList={() => {
                                                    }}/>
                                            </div>*/}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default AdSetsList
